export default [
    {
        path: '/wv/test',
        component: () => import('@/webview/test/index.vue')
    }
]